// Lazy load function
const lazyLoad = (file) => () =>
    import(/* webpackChunkName: "[request]" */ `@/views/finance/bank/${file}.vue`);

export default [
    {
        path: "/bank-accounts",
        name: "bank-accounts",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "BankAccounts",
        },
        components: {
            content: lazyLoad("bank-account-list"),
        },
    },
    {
        path: "/bank-accounts/create",
        name: "bank-account",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "BankAccounts",
        },
        components: {
            content: lazyLoad("bank-account"),
        },
    },
    {
        path: "/bank-accounts/review/:id",
        name: "bank-account-review",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "BankAccounts",
        },
        components: {
            content: lazyLoad("bank-account"),
        },
    },
    {
        path: "/bank-accounts/edit/:id",
        name: "bank-account-edit",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "BankAccounts",
        },
        components: {
            content: lazyLoad("bank-account"),
        },
    },

    {
        path: "/bank-accounts-transaction/review/:id",
        name: "bank-account-transaction",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "BankAccounts",
        },
        components: {
            content: lazyLoad("bank-account-transaction"),
        },
    },

    {
        path: "/bank-transactions",
        name: "bank-transactions",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "BankTransactions",
        },
        components: {
            content: lazyLoad("bank-transactions-list"),
        },
    },


    {
        path: "/sundry-transactions",
        name: "sundry-transactions",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "BankTransactions",
        },
        components: {
            content: lazyLoad("sundry-transactions-list"),
        },
    },

    {
        path: "/sundry-payment/:id",
        name: "sundry-payment",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "BankTransactions",
        },
        components: {
            content: lazyLoad("sundry-payment"),
        },
    },

    {
        path: "/sundry-receipt/:id",
        name: "sundry-receipt",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "BankTransactions",
        },
        components: {
            content: lazyLoad("sundry-receipt"),
        },
    },

    {
        path: "/bank-reconciliation/edit/:id",
        name: "bank-reconciliation-edit",
        meta: {
            requiresAuth: true,
            applicationFeatureCode: "BankReconciliation",
        },
        components: {
            content: lazyLoad("bank-reconciliation"),
        },
    },
];